import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import classes from './Sidenav.module.css';

const SideNav = () => {
  return (
    <div className={` ${classes.sidenav} position-fixed `} style={{width: "9%"}}>
      <div className="upper-line align-self-center"></div>
      <div className="social-icons-wrapper align-self-center my-2">
        <a
          className="d-block social-icon mb-2"
          href="https://twitter.com/JPhleg"
        >
          <FontAwesomeIcon icon={faTwitter} />
        </a>
        <a
          className="d-block social-icon mb-2"
          href="https://www.linkedin.com/in/joshua-moses-4117a7209/"
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </a>
        <a className="d-block social-icon" href="https://github.com/J0shcodes">
          <FontAwesomeIcon icon={faGithub} />
        </a>
      </div>
      <div className="bottom-line align-self-center"></div>
    </div>
  );
};

export default SideNav;
